import React from 'react'
export type FeatureFlagsContextType = {
  [key: string]: {
    name: string
    description: string
    isEnabled: boolean
    id: number
    createdAt: string
    updatedAt: string
  }
}
const FeatureFlagsContext = React.createContext<FeatureFlagsContextType>({})
export default FeatureFlagsContext
